import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DokladSk = {
	name: NAME,
	apiProvider,
	router,
};
